import { Component, OnInit, OnDestroy } from '@angular/core';
import { Cluster } from 'src/app/models/cluster.model';
import { Subscription } from 'rxjs';
import { ClustersService } from 'src/app/services/clusters.service';

@Component({
  selector: 'app-my-portfolio-current',
  templateUrl: './my-portfolio-current.component.html',
  styleUrls: ['./my-portfolio-current.component.scss']
})
export class MyPortfolioCurrentComponent implements OnInit, OnDestroy {

  clusterLoading: boolean = false;
  clusterLoadingSubscription: Subscription;
  currentCluster: Cluster;
  currentClusterSubscription: Subscription;
  clusterList: Cluster[];
  clusterListSubscription: Subscription;

  selectedCluster: Cluster;

  constructor(private clustersService: ClustersService) { }

  ngOnInit(): void {
    this.clusterListSubscription = this.clustersService.clusterListSubject.subscribe(
      (clusterList: Cluster[]) => {
        this.clusterList = clusterList;
      }
    );
    this.clustersService.emitClusterList();

    this.subscribeToCurrentCluster();
    this.subscribeToClusterLoading();
  }

  ngOnDestroy() {
    if (this.clusterListSubscription!=undefined) { this.clusterListSubscription.unsubscribe(); }
    if (this.currentClusterSubscription!=undefined) { this.currentClusterSubscription.unsubscribe(); }
    if (this.clusterLoadingSubscription!=undefined) { this.clusterLoadingSubscription.unsubscribe(); }
  }

  subscribeToCurrentCluster() {
    this.currentClusterSubscription = this.clustersService.currentClusterSubject.subscribe(
      (cluster: Cluster) => {
        this.currentCluster = cluster;
        this.selectedCluster = cluster;
      }
    );
    this.clustersService.emitCurrentCluster();
  }

  subscribeToClusterLoading() {
    this.clusterLoadingSubscription = this.clustersService.clusterLoadingSubject.subscribe(
      (clusterLoading: boolean) => {
        this.clusterLoading = clusterLoading;
      }
    );
    this.clustersService.emitClusterLoading();
  }

  onSelectCluster(cluster: Cluster) {
    this.selectedCluster = cluster;
  }

  onChangeCluster() {
    if (this.selectedCluster!=undefined) {
      this.clustersService.select(this.selectedCluster.id);
    } else {
      this.clustersService.select();
    }
  }

  onDeleteCluster() {
    this.clustersService.deleteCluster();
  }

  onViewReport() {
    if (this.selectedCluster!=undefined) {
      this.clustersService.viewReport(this.selectedCluster.id);
    }
  }

}
